import { defineStore } from 'pinia'

import { Cookie } from '@/utils/Cookie'


export const useOrderStore = defineStore('order', {
  state: () => ({
    items: [],
    total: 0,
    count: 0
  }),
  actions: {
    setOrderItems(items) {
      this.items = items
      this.count = items.length
      this.total = items.reduce((sum, item) => {
        const price = item.knowledgeVersion === "netVersion"
          ? item.netPrice
          : item.mirrorPrice
        return sum + (price || 0)
      }, 0) / 10000
    },
    clearOrder() {
      this.items = []
      this.total = 0
      this.count = 0
    }
  }
})
export const useUserStore = defineStore('user', {
  state: () => ({

    userInfo: JSON.parse(Cookie.get('userInfo')) || null, // 从 Cookie 获取
    token: JSON.parse(Cookie.get('token')) || ''
  }),
  actions: {
    setUserInfo(token, userInfo) {
      this.token = token
      this.userInfo = userInfo
      Cookie.set('token', JSON.stringify(token));
      Cookie.set('userInfo', JSON.stringify(userInfo));
    },
    clearUserInfo() {
      this.token = ''
      this.userInfo = null
      Cookie.remove('userInfo');
      Cookie.remove('token');
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    userName: (state) => state.userInfo?.realName || '登录'
  }
})
export const useEventStore = defineStore('eventStore', {
  state: () => ({
    currentEvent: null
  }),
  actions: {
    setEvent(event) {
      this.currentEvent = event;
    }
  }
});